import(/* webpackMode: "eager" */ "/codebuild/output/src3214958540/src/scaleup-applications/apps/scaleup-platform-ui/app/[...slug]/page.tsx");
